import React, { useRef, useState, useEffect, useCallback } from "react"
import Slider from "react-slick"
import Container from "@ecom/ui/components/Container"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"
import { IconButton } from "@material-ui/core"
import ChevronRightIcon from "@material-ui/icons/ChevronRight"
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft"
import { Card, CardLoader } from "./Card"
import * as styles from "./reviews.module.scss"
import { Review, settings, fetchReviews } from "./helpers"

type Props = {
  page?: "default" | "debet"
  orderNum?: string
}

export function Reviews({ orderNum, page = "default" }: Props) {
  const sliderRef = useRef<Slider | null>(null)
  const [reviews, setReviews] = useState<Review[] | null>(null)

  const getReviews = useCallback(async () => {
    try {
      const data = await fetchReviews(page)
      setReviews(data)
    } catch (error) {
      console.error("Ошибка при получении отзывов:", error)
    }
  }, [page, setReviews])

  useEffect(() => {
    getReviews()
  }, [getReviews])

  useEffect(() => {
    if (sliderRef.current) {
      sliderRef.current.slickPlay()
    }
  }, [])

  const gotoNext = () => {
    if (sliderRef.current) {
      sliderRef.current.slickNext()
    }
  }

  const gotoPrev = () => {
    if (sliderRef.current) {
      sliderRef.current.slickPrev()
    }
  }

  return (
    <section className={styles.section} data-exclude={orderNum}>
      <Container>
        <div className={styles.title_container}>
          <h2 className={styles.title}>Отзывы</h2>
          <div className={styles.btn_groupe}>
            <IconButton className={styles.btn} onClick={() => gotoPrev()}>
              <ChevronLeftIcon className={styles.angle} />
            </IconButton>
            <IconButton className={styles.btn} onClick={() => gotoNext()}>
              <ChevronRightIcon className={styles.angle} />
            </IconButton>
          </div>
        </div>
      </Container>
      {!reviews && (
        <Container>
          <div className={styles.reviews_loader_container}>
            {[1, 2, 3, 4, 5, 6].map((item) => (
              <CardLoader key={item} />
            ))}
          </div>
        </Container>
      )}
      {reviews && (
        <Container className={styles.reviews_container}>
          <Slider {...settings} ref={sliderRef} className={styles.slider_wrapper}>
            {reviews.map((item) => (
              <Card {...item} key={item.id} />
            ))}
          </Slider>
        </Container>
      )}
    </section>
  )
}
